import styled from "styled-components";

const hidden = `overflow: hidden;
overflowY: hidden;
overflowX: hidden;`;

export const Container = styled.div.attrs(({ active }) => ({
  "data-test": "spinner",
  "data-spinner": active,
}))`
  display: block;
  ${(props) => (props.active ? hidden : "")}
  height: 100%;
  position: absolute;
  width: 100%;
`;
